import { StandardsModalViewMoreButton } from "./StandardsModalViewMoreButton.component";

export { StandardsModalViewMoreButton };
